import { createAnalyticsReactModule } from '@modernhealth/analytics-core';

import {
  AnalyticsClient,
  AnalyticsPageviewProperties,
} from './AnalyticsClient';

export const {
  AnalyticsPageContext,
  AnalyticsProvider,
  AnalyticsClientContext,
  useAnalyticsClient,
  useAnalytics,
} = createAnalyticsReactModule<AnalyticsClient, AnalyticsPageviewProperties>();
